import { render } from "./PersonalInformationCard.vue?vue&type=template&id=081ae040&scoped=true"
import script from "./PersonalInformationCard.vue?vue&type=script&lang=js"
export * from "./PersonalInformationCard.vue?vue&type=script&lang=js"

import "./PersonalInformationCard.vue?vue&type=style&index=0&id=081ae040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081ae040"]])

export default __exports__